import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { getEnrollmentId } from '../utils/enrollmentUtil';
import * as CdpService from '../../services/CdpService';
import { Field, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';

const useSendEmail = (route: any, isCDPScriptLoaded: boolean): any => {
  const cdpState = useSelector((state: RootState) => state.cdpData);
  const [isLoaded, setIsLoaded] = useState(false);
  const router = useRouter();
  const sendEmailEvent = process.env.NEXT_PUBLIC_CDP_SENDEMAIL_EVENT as string;
  const { sitecoreContext } = useSitecoreContext();
  const siteSettings: any = sitecoreContext?.siteSettings;
  const isSendEmailEnabled = siteSettings?.enableEmailSendFeature?.value;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  useEffect(() => {
    const isOutcomePage = (route?.fields?.isOutcomePage as Field)?.value;
    if (isOutcomePage === true && isSendEmailEnabled && isCDPScriptLoaded) {
      const emailExtensionData = {
        enrollmentId: getEnrollmentId() || '',
        emailType: cdpState?.emailType || '',
      };
      CdpService.event(sendEmailEvent, emailExtensionData);
      setIsLoaded(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cdpState?.emailType, isCDPScriptLoaded, router?.query]);
  return isLoaded;
};

export default useSendEmail;
